<template>
  <div id="wrapper">
    <SidebarView :journal="true" :add-opening-or-closing-journal="true" :journal-visible="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <form @submit.prevent="submitJournal()" :add_or_edit="add_or_edit">
          <div class="mx-3">
            <div class="general-error d-flex justify-content-center">
              <errors v-if="form.message">
                {{ form.message }}
              </errors>
            </div>
            <div class="row mb-4">
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header pe-1 d-flex flex-row align-items-center justify-content-between">
                    <h6 class="m-0 fw-bold text-green">Year-End Account Closure/Opening</h6>
                    <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size">
                      <font-awesome-icon class="me-2" :icon="['fas', 'save']" />{{ save }}
                    </button>
                  </div>
                  <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <label class="akkurate-dark" for="middle_name">Posting Type <star></star></label>
                            <b-form-group>
                                <multiselect v-model="form.journal_type" name="coa_subhead" :options="journal_type_options" @input="refreshAllBalances"
                                class="mt-2 field-container" label="name" :custom-label="optionsLabel" required>
                                </multiselect>
                                <errors v-if="form.errors.journal_type">
                                {{ form.errors.journal_type[0] }}
                                </errors>
                            </b-form-group>
                        </div>

                        <div class="col-12 col-md-4">
                        <label class="akkurate-dark" for="recorded_date">Date<star></star></label>
                        <b-form-group id="recorded_date" label-for="recorded_date">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="date" :disabled="edit_date_pemission"
                            v-model="form.recorded_date" required></b-form-input>
                            <errors v-if="form.errors.recorded_date">
                            {{ form.errors.recorded_date[0] }}
                            </errors>
                        </b-form-group>
                        </div>

                        <div class="col-12 col-md-4">
                        <div class="d-flex">
                            <label class="akkurate-dark me-2" for="narration">Narration <star></star></label>
                            <!-- <b-form-checkbox id="checkbox-1" @change="desChecked" v-model="status" name="checkbox-1" value="accepted"
                            unchecked-value="not_accepted">
                            Apply for all
                            </b-form-checkbox> -->
                        </div>

                        <b-form-group id="narration" label-for="narration">
                            <b-form-textarea class="mt-2 fields" id="narration" placeholder="Enter Narration..."
                            v-model="form.narration"></b-form-textarea>
                            <errors v-if="form.errors.narration">
                            {{ form.errors.narration[0] }}
                            </errors>
                        </b-form-group>
                        </div>
                    </div>

                    <!-- <journal-form :form="form" :branch_options="branch_options"
                      @desChecked="updateStatus" :edit_date_pemission="edit_date_pemission"></journal-form> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="d-flex flex-row align-items-center justify-content-between">
                <div class="err-accounts">
                  <errors v-if="form.errors.accounts">
                    {{ form.errors.accounts[0] }}
                  </errors>
                </div>
                <div class="col-12 col-md-12">
                  <div class="card card-shape home-box">
                    <div class="card-header d-flex flex-row align-items-center py-2">
                      <h6 class="m-0 fw-bold text-green">Accounts</h6>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12 col-md-3">
                          <label class="akkurate-dark" for="gl_ledger">GLedger <star></star></label>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="dr_amount">Current Balance <star></star></label>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="dr_amount">DR Balance <star></star></label>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="cr_amount">CR Balance <star></star></label>
                        </div>
                        
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="dr_amount">Difference</label>
                        </div>

                      </div>
                      <div class="row" v-for="(field, index) in documents" :key="index">
                        <div class="col-12 col-md-3">
                          <b-form-group>
                            <multiselect v-model="field.coa_subhead" name="coa_subhead" :options="coa_subhead_options"
                            @input="updateCoaBalance(field)"
                              class="mt-2 field-container" label="name" :custom-label="nameWithLang" required>
                            </multiselect>
                            <errors v-if="form.errors.coa_subhead">
                              {{ form.errors.coa_subhead[0] }}
                            </errors>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group label-for="dr_amount">
                            <b-form-input id="dr_amount" name="dr_amount" class="mt-2 field-container fields"
                              :value="displayNumber(getBalance(field.coa_subhead))"
                              v-model="field.coa_subhead.amountStr"
                              type="text" step="any" disabled
                              required></b-form-input>
                            <errors v-if="form.errors.dr_amount">
                              {{ form.errors.dr_amount[0] }}
                            </errors>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group label-for="dr_amount">
                            <b-form-input id="dr_amount" name="dr_amount" class="mt-2 field-container fields"
                              type="number" step="any" v-model="field.dr_amount" :disabled="drDisabled(field)"
                              required></b-form-input>
                            <errors v-if="form.errors.dr_amount">
                              {{ form.errors.dr_amount[0] }}
                            </errors>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <b-form-input id="cr_amount" v-model="field.cr_amount" name="cr_amount"
                              class="mt-2 field-container fields" type="number" step="any" :disabled="crDisabled(field)"
                              required></b-form-input>
                            <errors v-if="form.errors.cr_amount">
                              {{ form.errors.cr_amount[0] }}
                            </errors>
                          </b-form-group>
                        </div>
                        
                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <b-form-input id="coa_description" name="coa_difference" :value="displayNumber(calculateDifference(field))"
                              class="mt-2 field-container fields" type="text"
                              disabled></b-form-input>
                            <errors v-if="form.errors.difference">
                              {{ form.errors.difference[0] }}
                            </errors>
                          </b-form-group>
                        </div>
                        <div class="col mt-auto">
                          <a title="Delete" class="btn btn-sm akkurate-danger-btn text-white"
                            @click="removeField(index)">
                            <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'trash']" /></span>
                          </a>
                        </div>
                      </div>
                      <!-- Displaying Total Debit and Total Credit -->
                      <div class="row mt-4 justify-content-end ">
                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <label>Total Debit</label>
                            <b-form-input class="field-container fields" type="text" :value="displayNumber(totalDebit)"
                              disabled></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <label>Total Credit</label>
                            <b-form-input class="field-container fields" type="text" :value="displayNumber(totalCredit)"
                              disabled></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <label>Total Difference</label>
                            <b-form-input class="field-container fields" type="text"
                              :value="displayNumber(totalDifference)" disabled></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-1 mt-auto">
                          <a title="Delete" class="btn btn-sm akkurate-green-btn text-white"
                             @click="addAccount">
                            <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'plus']" /></span>
                          </a>
                          <!-- <button type="button" @click="addAccount" class="btn akkurate-green-btn text-white btn-size">
                            <font-awesome-icon class="me-2" :icon="['fas', 'plus']" />
                          </button> -->
                        </div>
                      </div>
                      <p class="akkurate-danger small">{{ acc_error }}</p>
                      <!-- <div class="row mt-3">
                        <div class="col-md-12">
                          <button type="button" @click="addAccount" class="btn akkurate-green-btn text-white btn-size">
                            <font-awesome-icon class="me-2" :icon="['fas', 'plus']" /> Add
                          </button>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
      <footer></footer>
    </div>
  </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import Footer from "@/views/main/components/Footer.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import JournalForm from '../forms/JournalForm.vue'
import AddAccount from '../forms/modal/AddAccount.vue'
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import { hasPermission } from '@/helper';

export default {
  name: "JournalCreate",
  // watch: {
  //     fields: {
  //         deep: true,
  //         handler() {
  //             this.form.amount_requested = this.fields.reduce(
  //                 (total, field) => total + (field.difference || 0),
  //                 0
  //             )
  //         }
  //     }
  // },
  mounted() {
    this.loadPageOptions();
    this.checkPemission();
  },
  components: {
    SidebarView,
    Footer,
    TopbarView,
    JournalForm,
    AddAccount,
    Multiselect,
  },
  data() {
    return {
        ...this.initialState(),
        isLoading: false,
      coa_subhead_options: [],
      totalDifference:0,
      branch_options: [],
      add_or_edit: 'add',
      save: "Post",
      isSaving: false,
      acc_error: "",
      coa_desc_state: true,
        edit_date_pemission: true,
      journal_type_options: [
        { value: 'open', text: 'Opening' },
        { value: 'close', text: 'Closing' },
      ],
    };
  },
  computed: {
    totalDebit() {
    this.totalDifference = this.documents.reduce((sum, field) => sum + parseFloat(field.difference || 0), 0);
      return this.documents.reduce((sum, field) => sum + parseFloat(field.dr_amount || 0), 0);
    },
    totalCredit() {
    this.totalDifference = this.documents.reduce((sum, field) => sum + parseFloat(field.difference || 0), 0);
      
      return this.documents.reduce((sum, field) => sum + parseFloat(field.cr_amount || 0), 0);
    },
  },
  methods: {
      updateCoaBalance(field) {
        if (!field.coa_subhead || !field.coa_subhead.id) return; // safety

        const id = field.coa_subhead.id;

        // Ensure the coaBalances object exists
        if (!this.coaBalances) this.coaBalances = {};

        // Get the selected journal type ('open' or 'close')
        const journalType = this.form.journal_type?.value || 'open';

        // console.log(journalType);

        // Set balance based on journal type
        if (journalType === 'close') {
          field.coa_subhead.amount = this.coaBalances[id]?.closing_balance || 0;
        } else {
          // Default to 'open'
          field.coa_subhead.amount = this.coaBalances[id]?.opening_balance || 0;
        }
      },

      // Refresh all balances when journal_type changes
      refreshAllBalances() {
        this.documents.forEach(doc => {
          this.updateCoaBalance(doc);
        });
      },

      async getBalance(coa) {
        // console.log(coa)
        if (!this.form.recorded_date || !coa?.id) return;

        // console.log(this.form.recorded_date)
        const currentDate = new Date(this.form.recorded_date);
        const prevDate = new Date(currentDate - 1)

        const day = prevDate.getDate()
        const month = prevDate.getMonth() + 1
        const year = prevDate.getFullYear()
                  
        const prev_date = `${year}-${month<10? "0"+month:month}-${day<10? "0"+day:day}`
         
        try {
          const response = await ApiService.post('/journals/financial-year-transaction/coa-balances', {
              date: this.form.recorded_date,
              prev_date: prev_date,
              coa_id: coa?.id
          });


          coa.balances = response.data.balances


          if(this.form.journal_type?.value == "open"){
            coa.amount = coa.balances.opening_balance
          } else {
            coa.amount =  coa.balances.closing_balance
          }

        } catch (error) {
          console.error('Error loading balances:', error);
        }

        coa.amountStr = this.displayNumber(coa.amount || 0)
        return coa.amountStr;
      },

      calculateDifference(field) {
        const newBalance = field.dr_amount || field.cr_amount || 0
        const currentAmount = Number(field.coa_subhead.amount) || 0

        
        field.difference = newBalance - currentAmount

        if (field.difference < 0) {
            field.difference = 0
        } 

        // this.form.amount_requested += field.difference
        return field.difference
    },
    checkPemission() {
      if (hasPermission('journal_management_edit_date')) {
        this.edit_date_pemission =  false
      } else {
        this.edit_date_pemission =  true
      }
    },
    loadPageOptions() {
      this.$Progress.start();
      this.isLoading = true;
      
      ApiService.get("/journals/dropdown")
        .then((response) => {
          this.coa_subhead_options = response.data.coa_subheads;
          // this.branch_options = response.data.branches;
          this.form.branch = response.data.user_branch;
          // console.log(this.form.branch)
          // console.log(response.data.branches?.[0].name);
          // console.log(response.data);
          this.isLoading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$Progress.fail();
        });
    },

    addAccount() {
      this.documents.push({ dr_amount: "", cr_amount: "", coa_subhead: { id: "", name: "", code: "", coahead:{}, amount: 0 } });
      this.acc_error = ""
      this.isSaving = false
    },
    removeField(index) {
      this.documents.splice(index, 1);

      this.acc_error = ""
      this.isSaving = false
    },
    submitJournal() {
      this.isSaving = true;
      this.$Progress.start();
      this.save = "Posting..."
      this.form.vouch_journ_coa_accounts = this.documents

      // console.log("Form:", this.form);
      this.form.amount_requested = this.totalDifference

      // console.log(this.form.recorded_date)
        const currentDate = new Date(this.form.recorded_date);
        const prevDate = new Date(currentDate - 1)

        const day = prevDate.getDate()
        const month = prevDate.getMonth() + 1
        const year = prevDate.getFullYear()
                  
        const prev_date = `${year}-${month<10? "0"+month:month}-${day<10? "0"+day:day}`
      this.form.prev_date = prev_date;

      ApiService.post("/journals/financial-year-transaction/store", this.form)
        .then((response) => {
          this.isSaving = false;
          this.$Progress.finish();
          this.save = "Post"
          toast.fire({
            icon: "success",
            title: response.data.message,
          });

          this.form = this.initialState().form;
          this.documents = [{ dr_amount: "", cr_amount: "", difference: "", coa_subhead: { id: "", name: "", code: "", coahead:{} } }]
          this.isSaving = false;
        })
        .catch((error) => {
          this.isSaving = false;
          this.$Progress.fail();
          this.save = "Post"
          if (error.response.data) {
            this.form.errors = error.response.data.message;
          }
          //error message
          if (error.response.data.message) {
            this.form.message = error.response.data.message;
          }
          // console.log(error.response.data)
        });
    },

    drDisabled(field) {
      if (field.cr_amount.length > 0) {
        field.dr_amount = 0;
        return true;
      }
    },
    crDisabled(field) {
      if (field.dr_amount.length > 0) {
        field.cr_amount = 0;
        return true;
      }
    },
    updateStatus(newStatus) {
      // console.log(newStatus);
      this.coa_desc_state = newStatus === 'accepted';
    },

    documentFile(data) {
      // console.log(data);
      this.form.receipt_name = data.name;
      this.form.receipt_location = data.path
      },
    optionsLabel({ text, value }) {
        console.log(text, value);
        return `${text}` ;
    },
    nameWithLang({ name, code, coabranch }) {
      return `${name} — ${code == undefined ? "" : code} ${coabranch?.name == undefined ? "" : coabranch?.name}`;
    },
    initialState() {
      return {
        form: {
          branch: "",
          expected_amount: "",
          amount_requested: 0,
          recorded_date: new Date().toLocaleDateString('en-CA'),
          narration: "",
          receipt_name: "",
          receipt_location: "",
          vouch_journ_coa_accounts: [],
              errors: [],
          journal_type: {value: 'open', text: 'Opening' },
          prev_date: "",
        },
        documents: [{ dr_amount: "", cr_amount: "", coa_subhead: { id: "", name: "", code: "", coahead:{} } }],
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style>
.hideTrans{
    opacity: 0 !important;
  }
</style>